import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Text from '../Text';
import CustomTooltip from '../CustomTooltip';

const Label = styled.label``;

const InputLegend = ({
  mb = 16,
  mt = 0,
  type = 'primary',
  label,
  required,
  tooltipKey,
  htmlFor,
  hiddenLabel,
}) => {
  return (
    <Label
      className={`d-flex ${hiddenLabel ? 'visually-hidden' : ''}`}
      htmlFor={htmlFor}
      as={htmlFor ? 'label' : 'div'}
    >
      <Text type="h3" mb={mb} mt={mt} className={required ? 'mandatory' : ''}>
        {label}
      </Text>
      {tooltipKey && (
        <CustomTooltip
          title={label}
          tooltipKey={tooltipKey}
          type={type}
          className="align-self-start"
          mt={-4}
        />
      )}
    </Label>
  );
};

InputLegend.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.bool,
  tooltipKey: PropTypes.string,
  mb: PropTypes.number,
  mt: PropTypes.number,
  type: PropTypes.oneOf(['primary', 'secondary']),
  htmlFor: PropTypes.string,
  hiddenLabel: PropTypes.bool,
};

export default InputLegend;
